<template>
  <div class="modal-wrapper" :class="{'shown' : visible}">
    <div class="bg" v-on:click="hide()"></div>
    <div class="modal-modal" :class="{'sm' : sm}">
      <div class="navbar navbar-light">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href title="Close" v-on:click.prevent="hide()">
              <svg class="bi" fill="currentColor" width="24" height="24">
                <use xlink:href="~bootstrap-icons/bootstrap-icons.svg#arrow-left" />
              </svg>
            </a>
          </li>
        </ul>
        <span v-if="title" class="navbar-brand me-auto" :title="title">{{title}}</span>
      </div>
      <slot>

      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: {
      type: String,
      required: false
    },
    sm: {
      type: Boolean,
      required: false
    },
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    toggle() {
      this.visible = !this.visible;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/styles/_variables";
.modal-wrapper {
  visibility: hidden;
  transition: visibility 0.7s linear;
  padding: 2rem;
  position: fixed;
  top: calc(#{$navbar-padding-y * 2 + $nav-link-height} + 1px);
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  overflow: auto;
    
  @media (min-width: 768px) {
      margin-bottom: calc(#{$navbar-padding-y * 2 + $nav-link-height} + 1px);
  }

  @media (max-width: 575px) {
    top: calc(
      #{$navbar-padding-y * 2 + 0.9 * $nav-link-height + $nav-link-height} + 1px
    );
    padding: 1rem;
  }

  > .bg {
    background-color: change-color($body-bg, $alpha: 0.75);
    position: fixed;
    top: inherit;
    bottom: inherit;
    left: inherit;
    right: inherit;
    opacity: 0;
    backdrop-filter: grayscale(0%) blur(0px);
    transition: opacity 0.35s ease 0.25s, backdrop-filter 0.35s ease 0.25s;
    @media (prefers-color-scheme: dark) {
      background-color: change-color($body-bg-darkmode, $alpha: 0.75);
    }
  }

  > .modal-modal {
    position: relative;
    z-index: 1;
    opacity: 0;
    transform: translateY(80px);
    margin: 0 auto;
    border: 1px solid #ddd;
    background-color: #fff;
    //min-height: 500px;
    width: 1200px;
    max-width: 100%;
    transition: opacity 0.35s ease, transform 0.35s ease;

    &.sm {
      width: 600px;
    }

    @media (prefers-color-scheme: dark) {
      border-color: $border-color-darkmode;
      background-color: $body-bg-darkmode;
      color: $body-color-darkmode;

      .navbar-nav .nav-link {
        color: change-color($body-color-darkmode, $alpha: 0.55);

        &:hover {
          color: change-color($body-color-darkmode, $alpha: 0.75);
        }

        &.active {
          color: $body-color-darkmode;
        }
      }
    }

    > .navbar {
      border-bottom: 1px solid #ddd;
      flex-wrap: nowrap;
      padding-right: 0.5rem;
      padding-left: 0.5rem;

      @media (prefers-color-scheme: dark) {
        border-color: $border-color-darkmode;
        background-color: $body-bg-darkmode;
        color: $body-color-darkmode;
      }

      .nav-link {
        padding-left: 1rem;
        padding-right: 1rem;
      }

      .navbar-brand {
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 0.5rem;

        @media (prefers-color-scheme: dark) {
          color: $body-color-darkmode;
        }
      }
    }
  }

  &.shown {
    visibility: visible;

    > .bg {
      opacity: 1;
      backdrop-filter: grayscale(100%) blur(5px);
      transition: opacity 0.35s ease, backdrop-filter 0.35s ease;
    }

    > .modal-modal {
      opacity: 1;
      transform: none;
      transition: opacity 0.35s ease 0.25s, transform 0.35s ease 0.25s;
    }
  }
}

.modal-close-btn {
  position: absolute;
  right: 100%;
  top: 0;
}

</style>
